@if (!erreurRecuperation()) {
  <div>
    <app-data-table
      [data]="reasons()"
      [columns]="tableColumns"
      [clickable]="true"
      (selectionLigne)="openEditModal($event)"
    />
    <div class="footer">
      <app-button
        variant="primary"
        [label]="'GLOBAL.AJOUTER' | translate"
        [addIconLeft]="true"
        (clicked)="openAddModal()"
      >
        <i slot="icon-left" class="fas fa-plus"></i>
      </app-button>
    </div>
  </div>
}
@if (erreurRecuperation()) {
  <div class="custom-alert custom-alert-sm">
    {{'GLOBAL.ERREUR_RECUP_DONNEES' | translate}}
  </div>
}
